<template>
  <v-container fluid id="downloadApplicationFiles">
    <div v-if="loanApplication">
      <v-row no-gutters justify="center">
        <v-card color="primary" max-width="95%">
          <v-row no-gutters>
            <v-select
              v-model="currentImageName"
              :items="imageNames"
              @change="whatImage(currentImageName)"
              :label="currentImageName"
              solo
              dense
              dark
              flat
              color="white"
              background-color="green darken-1"
              style="
                margin-bottom: -20px;
                margin-top: 4px;
                margin-left: 4px;
                margin-right: 4px;
              "
            ></v-select>
          </v-row>
          <v-row v-if="renderImg" no-gutters class="pb-1 px-1">
            <img
              style="border-radius: 4px; max-width: 100%; max-height: 88vh"
              lazy-src="@/assets/placeholder-image.png"
              loading="eager"
              :src="currentImage"
            />
          </v-row>
          <v-row v-else-if="renderPdf" no-gutters class="pb-4 px-4">
            <span class="text-center white--text">
              This document is a PDF and can't be viewed here, download
              below</span
            >
          </v-row>
          <v-row no-gutters class="pb-1 px-1">
            <v-btn
              depressed
              dark
              color="green darken-1"
              block
              :disabled="downloadLoading"
              :loading="downloadLoading"
              @click="downloadFile"
            >
              Download
            </v-btn>
          </v-row>
        </v-card>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import {
  Employee,
  LoanApplication,
  LoanType,
  Company,
  CompanyLoanType,
} from "@/models";
import { layout } from "@/mixins";
import { Storage } from "@aws-amplify/storage";
import { DataStore, syncExpression } from "aws-amplify";
import _ from "lodash";

export default {
  mixins: [layout],
  name: "DownloadApplicationFiles",

  components: {},

  data: () => ({
    renderImg: false,
    renderPdf: false,
    downloadLoading: false,
    imageNames: [],
    theme: "print",
    currentImageName: "Signature",
    currentImage: "",
    proofOfBankImage: null,
    identificationImage: null,
    signatureImage: null,
    payslipImages: [],
    loanApplication: null,
    loading: Boolean,
  }),

  beforeMount() {
    this.loading = true;
    this.getLoanApplication();
  },

  methods: {
    async getLoanApplication() {
      try {
        await DataStore.stop();
        DataStore.configure({
          syncExpressions: [
            syncExpression(LoanApplication, () => {
              return (LoanApplication) =>
                LoanApplication.id("eq", this.$route.params.applicationId);
            }),
            syncExpression(Employee, () => {
              return (Employee) => Employee.id("eq", null);
            }),
            syncExpression(LoanType, () => {
              return (LoanType) => LoanType.id("eq", null);
            }),
            syncExpression(Company, () => {
              return (Company) => Company.id("eq", null);
            }),
            syncExpression(CompanyLoanType, () => {
              return (CompanyLoanType) => CompanyLoanType.id("eq", null);
            }),
          ],
        });
        await DataStore.start();
        //-------------------------------------------------------------------------
        this.subscription = DataStore.observeQuery(LoanApplication, (la) =>
          la.id("eq", this.$route.params.applicationId)
        ).subscribe(async (snapshot) => {
          const { items, isSynced } = snapshot;
          if (isSynced && items.length > 0) {
            this.loanApplication = _.cloneDeep(items[0]);

            this.signatureImage = await Storage.get(
              this.loanApplication.signatureImage,
              {
                level: "public",
              }
            );
            if (this.signatureImage) {
              this.imageNames.push("Signature");
            }
            this.proofOfBankImage = await Storage.get(
              this.loanApplication.proofOfBank,
              {
                level: "public",
              }
            );
            if (this.proofOfBankImage) {
              this.imageNames.push("Proof of Banking");
            }
            this.identificationImage = await Storage.get(
              this.loanApplication.identification,
              {
                level: "public",
              }
            );
            if (this.identificationImage) {
              this.imageNames.push("Identification/Passport");
            }
            for (let i in this.loanApplication.payslips) {
              this.payslipImages.push(
                await Storage.get(this.loanApplication.payslips[i], {
                  level: "public",
                })
              );
              this.imageNames.push("Payslip " + (parseInt(i) + 1));
            }
            this.whatImage("Signature");
            this.loading = false;
            this.subscription.unsubscribe();
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    whatImage(image) {
      try {
        if (image === "Signature") {
          this.currentImage = this.signatureImage;
          this.currentImageName = "Signature";
          let fileName = this.loanApplication.signatureImage.substring(
            this.loanApplication.signatureImage.lastIndexOf("/") + 1
          );
          if (fileName.includes(".pdf")) {
            this.renderPdf = true;
            this.renderImg = false;
          } else {
            this.renderPdf = false;
            this.renderImg = true;
          }
        } else if (image === "Proof of Banking") {
          this.currentImage = this.proofOfBankImage;
          this.currentImageName = "Proof of Banking";
          let fileName = this.loanApplication.proofOfBank.substring(
            this.loanApplication.proofOfBank.lastIndexOf("/") + 1
          );
          if (fileName.includes(".pdf")) {
            this.renderPdf = true;
            this.renderImg = false;
          } else {
            this.renderPdf = false;
            this.renderImg = true;
          }
        } else if (image === "Identification/Passport") {
          this.currentImage = this.identificationImage;
          this.currentImageName = "Identification/Passport";
          let fileName = this.loanApplication.identification.substring(
            this.loanApplication.identification.lastIndexOf("/") + 1
          );
          if (fileName.includes(".pdf")) {
            this.renderPdf = true;
            this.renderImg = false;
          } else {
            this.renderPdf = false;
            this.renderImg = true;
          }
        } else {
          let payslipNum = parseInt(image.charAt(image.length - 1));
          this.currentImage = this.payslipImages[payslipNum - 1];
          this.currentImageName = "Payslip " + payslipNum;
          let fileName = this.loanApplication.payslips[
            payslipNum - 1
          ].substring(
            this.loanApplication.payslips[payslipNum - 1].lastIndexOf("/") + 1
          );
          if (fileName.includes(".pdf")) {
            this.renderPdf = true;
            this.renderImg = false;
          } else {
            this.renderPdf = false;
            this.renderImg = true;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async downloadFile() {
      try {
        this.downloadLoading = true;
        let file = null;
        let fileName = "";
        if (this.currentImageName === "Signature") {
          fileName = this.loanApplication.signatureImage.substring(
            this.loanApplication.signatureImage.lastIndexOf("/") + 1
          );
          file = await Storage.get(this.loanApplication.signatureImage, {
            level: "public",
            download: true,
          });
        } else if (this.currentImageName === "Proof of Banking") {
          fileName = this.loanApplication.proofOfBank.substring(
            this.loanApplication.proofOfBank.lastIndexOf("/") + 1
          );
          file = await Storage.get(this.loanApplication.proofOfBank, {
            level: "public",
            download: true,
          });
        } else if (this.currentImageName === "Identification/Passport") {
          fileName = this.loanApplication.identification.substring(
            this.loanApplication.identification.lastIndexOf("/") + 1
          );
          file = await Storage.get(this.loanApplication.identification, {
            level: "public",
            download: true,
          });
        } else {
          let payslipNum = parseInt(
            this.currentImageName.charAt(this.currentImageName.length - 1)
          );
          fileName = this.loanApplication.payslips[payslipNum - 1].substring(
            this.loanApplication.payslips[payslipNum - 1].lastIndexOf("/") + 1
          );
          file = await Storage.get(
            this.loanApplication.payslips[payslipNum - 1],
            {
              level: "public",
              download: true,
            }
          );
        }
        const url = URL.createObjectURL(file.Body);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName || "download";
        const clickHandler = () => {
          setTimeout(() => {
            URL.revokeObjectURL(url);
            a.removeEventListener("click", clickHandler);
          }, 150);
        };
        a.addEventListener("click", clickHandler, false);
        a.click();
        this.downloadLoading = false;
        return a;
      } catch (error) {
        this.downloadLoading = false;
        console.log(error);
      }
    },
  },
  computed: {},
};
</script>
<style>
.v-list-item__title {
  font-size: 16px !important;
}
</style>